/* eslint-disable indent */

import { availableLanguages } from './i18n';

/* eslint-disable comma-dangle */
const jsonAppData = {
	headerMenu: [
		{
			title: 'de',
		},
		{
			title: 'fr',
		},
		{
			title: 'it',
		},
		{
			title: 'en',
		},
	],
	pageNavigation: [
		{
			label: 'login',
			url: '',
		},
		{
			label: 'myCode',
			url: '',
		},
		{
			label: 'dashboard',
			url: '',
		},
		{
			label: 'account',
			url: '/account',
		},
		{
			label: 'logout',
			url: '',
		},
		{
			label: 'adminDashboard',
			url: '',
		},
	],
	workflowNavigation: [
		{
			label: 'configure',
			url: '/',
		},
		{
			label: 'cart',
			url: '/cart',
		},
		{
			label: 'requestOrOrder',
			url: '/get-my-glass',
		},
	],
	glassConfigEditOptions: [
		{
			label: 'edit',
		},
		{
			label: 'delete',
		},
		{
			label: 'saveAsPdf',
		},
	],
	draftsConfigurationDropdown: [
		{
			label: 'duplicate',
		},
		{
			label: 'edit',
		},
		{
			label: 'saveAsPdf',
		},
		{
			label: 'delete',
		},
	],
	orderAndRequestConfigurationDropdown: [
		{
			label: 'duplicate',
		},
		{
			label: 'saveAsPdf',
		},
		// {
		// 	label: 'delete',
		// },
	],
	openOrderAndRequestConfigurationDropdown: [
		{
			label: 'complete',
		},
		{
			label: 'delete',
		},
	],
	closedOrderAndRequestConfigurationDropdown: [
		{
			label: 'reopen',
		},
		{
			label: 'delete',
		},
	],
	clientsListDropdown: [
		{
			label: 'open',
		},
		{
			label: 'delete',
		},
	],
	cartPage: {
		glassConfig: {
			fireResistant: {
				selected: 'Brandschutzglas EI30',
				options: ['Brandschutzglas EI30'],
			},
			spacer1: {
				selected: '15MM',
				options: ['15MM', '16MM', '17MM'],
			},
			gas1: {
				selected: 'krypton',
				options: ['krypton'],
			},
			middleGlass: {
				selected: 'ESG Extraweiss 5mm',
				options: ['ESG Extraweiss 5mm'],
			},
			spacer2: {
				selected: '16MM',
				options: ['16MM'],
			},
			gas2: {
				selected: 'krypton',
				options: ['krypton'],
			},
			outsideGlass: {
				selected: 'vsg 16-2 klarfolie',
				options: ['vsg 16-2 klarfolie'],
			},
			structure: {
				selected: '2-glazed',
				options: ['1-glazed (mono)', '2-glazed-ISO', '3-glazed-ISO'],
			},
			manufacturer: {
				selected: 'AGC',
				options: ['Glas Trösch', 'AGC', 'Pilkington', 'Hero-Fire'],
			},
			fireResistanceClass: {
				selected: 'EI30',
				options: ['EI30', 'EI60', 'EI90'],
			},
			insulation: {
				selected: 'U-Value 5.4',
				options: ['U-Value 5.4', 'U-Value 1.7'],
			},
			application: {
				selected: 'Inside',
				options: ['Inside', 'Inside/Outside', 'Outside/Outside'],
			},
			whiteGlass: {
				selected: 'checked',
				options: ['checked', 'unchecked'],
			},
			resistanceClass: {
				selected: 'RC 2 (WK 2) / P4A',
				options: [
					'RC 2 (WK 2) / P4A',
					'RC 3 (WK 3) / P5A',
					'RC 4 (WK 4) / P6B',
					'RC 5 (WK 5) / P7B',
					'RC 6 (WK 6) / P8B',
				],
			},
			buttJoints: {
				selected: 'unchecked',
				options: ['checked', 'unchecked'],
			},
			sound: {
				selected: 'wert',
				options: ['wert'],
			},
		},
		glassConfigTableHeadingRow: [
			{
				label: 'length',
			},
			{
				label: 'width',
			},
			{
				label: 'quantity',
			},
			{
				label: 'form',
			},
			{
				label: 'notes',
			},
			{
				label: 'cantonalInsurance',
			},
			{
				label: 'pc',
			},
			{
				label: 'pos',
			},
			{
				label: 'kg',
			},
			{
				label: 'price',
			},
		],
		glassConfigTable: [
			{
				row: [
					{
						name: 'length',
						value: '2000',
					},
					{
						name: 'width',
						value: '1000',
					},
					{
						name: 'quantity',
						value: '2',
					},
					{
						name: 'form',
						value: 'checked',
					},
					{
						name: 'notes',
						value: '',
					},
				],
			},
			{
				row: [
					{
						name: 'length',
						value: '1130',
					},
					{
						name: 'width',
						value: '300',
					},
					{
						name: 'quantity',
						value: '1',
					},
					{
						name: 'form',
						value: 'unchecked',
					},
					{
						name: 'notes',
						value: '',
					},
				],
			},
		],
	},
	guestForm: [
		{
			keyForI18n: 'userGenderPlaceholder',
			id: 'guestGender',
			options: [
				{ value: 'male', label: 'userGenderMale' },
				{ value: 'female', label: 'userGenderFemale' },
				{ value: 'div', label: 'userGenderDiv' },
			],
		},
		{
			keyForI18n: 'userCompanyPlaceholder',
			id: 'guestUserCompanyName',
			type: 'text',
			isRequired: true,
		},
		{
			keyForI18n: 'userNamePlaceholder',
			id: 'guestUserName',
			type: 'text',
			isRequired: true,
		},
		{
			keyForI18n: 'userCompanyEmailPlaceholder',
			id: 'guestUserEmail',
			type: 'email',
			isRequired: true,
		},
		{
			keyForI18n: 'userCompanyVATNumberPlaceholder',
			id: 'guestUserCompanyVATNumber',
			type: 'text',
			focusAutoFillValue: 'CHE-',
		},
		{
			keyForI18n: 'userFunctionPlaceholder',
			id: 'guestFunction',
			options: [
				{ value: 'owner', label: 'userFunctionOwner' },
				{ value: 'co-owner', label: 'userFunctionCoOwner' },
				{ value: 'management', label: 'userFunctionManagement' },
				{
					value: 'executive management',
					label: 'userFunctionExecutiveManagement',
				},
				{
					value: 'purchasing / procurement',
					label: 'userFunctionPurchasingProcurement',
				},
				{ value: 'sales', label: 'userFunctionSales' },
				{ value: 'project management', label: 'userFunctionProjectManagement' },
				{
					value: 'calculation / costing',
					label: 'userFunctionCalculationCosting',
				},
				{
					value: 'administrative processing',
					label: 'userFunctionAdministrativeProcessing',
				},
				{ value: 'other', label: 'userFunctionOther' },
			],
		},
		{
			keyForI18n: 'userStreetPlaceholder',
			id: 'guestUserCompanyStreet',
			type: 'text',
		},
		{
			keyForI18n: 'userZIPPlaceholder',
			id: 'guestUserCompanyZIP',
			type: 'text',
		},
		{
			keyForI18n: 'userCityPlaceholder',
			id: 'guestUserCompanyCity',
			type: 'text',
		},
		{
			keyForI18n: 'userPhonePlaceholder',
			id: 'guestUserCompanyPhone',
			type: 'text',
		},
	],
	accountPage: {
		accountCompanyForm: [
			{
				keyForI18n: 'userCompanyPlaceholder',
				id: 'userCompany',
				type: 'text',
			},
			{
				keyForI18n: 'userStreetPlaceholder',
				id: 'userStreet',
				type: 'text',
			},
			{
				keyForI18n: 'userZIPPlaceholder',
				id: 'userZIP',
				type: 'text',
			},
			{
				keyForI18n: 'userCityPlaceholder',
				id: 'userCity',
				type: 'text',
			},
			{
				keyForI18n: 'userPhonePlaceholder',
				id: 'userPhone',
				type: 'text',
			},
		],
		accountUserForm: [
			{
				keyForI18n: 'userFirstNamePlaceholder',
				id: 'userFirstName',
				type: 'text',
			},
			{
				keyForI18n: 'userLastNamePlaceholder',
				id: 'userLastName',
				type: 'text',
			},
			{
				keyForI18n: 'userEmailPlaceholder',
				id: 'userEmail',
				type: 'email',
				iconName: 'mail',
			},
			{
				keyForI18n: 'userPasswordPlaceholder',
				id: 'userPassword',
				type: 'password',
				iconName: 'lock',
			},
			{
				keyForI18n: 'repeatPasswordPlaceholder',
				id: 'userRepeatPassword',
				type: 'password',
				iconName: 'lock',
			},
		],
	},
	registrationNewCompanyUserForm: [
		{
			keyForI18n: 'userEmailPlaceholder',
			id: 'userEmail',
			type: 'email',
			iconName: 'mail',
		},
		{
			keyForI18n: 'userPasswordPlaceholder',
			id: 'userPassword',
			type: 'password',
			iconName: 'lock',
		},
		{
			keyForI18n: 'repeatPasswordPlaceholder',
			id: 'userRepeatPassword',
			type: 'password',
			iconName: 'lock',
		},
		{
			keyForI18n: 'userCompanyPlaceholder',
			id: 'companyName',
			type: 'text',
			disabled: true,
		},
		{
			keyForI18n: 'userFirstNamePlaceholder',
			id: 'userFirstName',
			type: 'text',
		},
		{
			keyForI18n: 'userLastNamePlaceholder',
			id: 'userLastName',
			type: 'text',
		},
		{
			keyForI18n: 'userGenderPlaceholder',
			id: 'userGender',
			isRequired: true,
			options: [
				{ value: 'male', label: 'userGenderMale' },
				{ value: 'female', label: 'userGenderFemale' },
				{ value: 'div', label: 'userGenderDiv' },
			],
		},
		{
			keyForI18n: 'userFunctionPlaceholder',
			id: 'userFunction',
			isRequired: false,
			options: [
				{ value: 'owner', label: 'userFunctionOwner' },
				{ value: 'co-owner', label: 'userFunctionCoOwner' },
				{ value: 'management', label: 'userFunctionManagement' },
				{
					value: 'executive management',
					label: 'userFunctionExecutiveManagement',
				},
				{
					value: 'purchasing / procurement',
					label: 'userFunctionPurchasingProcurement',
				},
				{ value: 'sales', label: 'userFunctionSales' },
				{ value: 'project management', label: 'userFunctionProjectManagement' },
				{
					value: 'calculation / costing',
					label: 'userFunctionCalculationCosting',
				},
				{
					value: 'administrative processing',
					label: 'userFunctionAdministrativeProcessing',
				},
				{ value: 'other', label: 'userFunctionOther' },
			],
		},
	],
	registrationNewUserForm: [
		{
			keyForI18n: 'userEmailPlaceholder',
			id: 'userEmail',
			type: 'email',
			iconName: 'mail',
			isRequired: true,
		},
		{
			keyForI18n: 'userPasswordPlaceholder',
			id: 'userPassword',
			type: 'password',
			iconName: 'lock',
			isRequired: true,
		},
		{
			keyForI18n: 'repeatPasswordPlaceholder',
			id: 'userRepeatPassword',
			type: 'password',
			iconName: 'lock',
			isRequired: true,
		},
		{
			keyForI18n: 'userGenderPlaceholder',
			id: 'userGender',
			isRequired: true,
			options: [
				{ value: 'male', label: 'userGenderMale' },
				{ value: 'female', label: 'userGenderFemale' },
				{ value: 'div', label: 'userGenderDiv' },
			],
		},
		{
			keyForI18n: 'i18n:language',
			id: 'userCompanyLanguage',
			type: 'text',
			isRequired: true,
			options: Object.keys(availableLanguages).map(l => {
				return {
					value: l,
					label: `${availableLanguages[l].flag} ${availableLanguages[l].nativeText}`,
				};
			}),
		},
		{
			keyForI18n: 'userCompanyPlaceholder',
			id: 'userCompanyName',
			type: 'text',
			isRequired: true,
		},
		{
			keyForI18n: 'userCompanyVATNumberPlaceholder',
			id: 'userCompanyVATNumber',
			type: 'text',
			isRequired: true,
		},
		{
			keyForI18n: 'userFirstNamePlaceholder',
			id: 'userFirstName',
			type: 'text',
			isRequired: true,
		},
		{
			keyForI18n: 'userLastNamePlaceholder',
			id: 'userLastName',
			type: 'text',
			isRequired: true,
		},
		{
			keyForI18n: 'userFunctionPlaceholder',
			id: 'userFunction',
			isRequired: false,
			options: [
				{ value: 'owner', label: 'userFunctionOwner' },
				{ value: 'co-owner', label: 'userFunctionCoOwner' },
				{ value: 'management', label: 'userFunctionManagement' },
				{
					value: 'executive management',
					label: 'userFunctionExecutiveManagement',
				},
				{
					value: 'purchasing / procurement',
					label: 'userFunctionPurchasingProcurement',
				},
				{ value: 'sales', label: 'userFunctionSales' },
				{ value: 'project management', label: 'userFunctionProjectManagement' },
				{
					value: 'calculation / costing',
					label: 'userFunctionCalculationCosting',
				},
				{
					value: 'administrative processing',
					label: 'userFunctionAdministrativeProcessing',
				},
				{ value: 'other', label: 'userFunctionOther' },
			],
		},
		{
			keyForI18n: 'userStreetPlaceholder',
			id: 'userCompanyStreet',
			type: 'text',
			isRequired: true,
		},
		{
			keyForI18n: 'userZIPPlaceholder',
			id: 'userCompanyZIP',
			type: 'text',
			isRequired: true,
		},
		{
			keyForI18n: 'userCityPlaceholder',
			id: 'userCompanyCity',
			type: 'text',
			isRequired: true,
		},
		{
			keyForI18n: 'userPhonePlaceholder',
			id: 'userCompanyPhone',
			type: 'tel',
			isRequired: true,
		},
	],
	loginForm: [
		{
			keyForI18n: 'baseFormPlaceholders:userEmailPlaceholder',
			id: 'userLoginEmail',
			type: 'email',
			iconName: 'mail',
		},
		{
			keyForI18n: 'baseFormPlaceholders:userPasswordPlaceholder',
			id: 'userLoginPassword',
			type: 'password',
			iconName: 'lock',
		},
	],
	defaultGlassPositionsData: [
		{
			row: [
				{
					name: 'length',
					value: '',
				},
				{
					name: 'width',
					value: '',
				},
				{
					name: 'quantity',
					value: '',
				},
				{
					name: 'form',
					value: 'unchecked',
				},
				{
					name: 'cantonalInsurance',
					value: '',
				},
				{
					name: 'notes',
					value: '',
				},
			],
		},
	],
};

export default jsonAppData;
